export enum baseAction {
  ContentItems_Loaded = 'ContentItems_Loaded',
  Introduction_Dismiss = 'Introduction_Dismiss',
}

export const dismissIntroduction = () => ({
  type: baseAction.Introduction_Dismiss,
});
